import UIComponent from "../component";

export class BtnScrollUp extends UIComponent {
    init() {
        this.on('click', this.scrollUp.bind(this));
    }

    scrollUp() {
        document.body.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }
}
